// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pfYHF","rootNoMargin":"styles_rootNoMargin__kHCX4"};